import * as App from "./application";
import * as Authn from "./authentication";
import * as config from "./config.json";

import "./webawesome.js";

const STORAGE_SESSION_TOKEN = "session-token";

const baseUrl = window.location.origin;

const sessionToken = localStorage.getItem(STORAGE_SESSION_TOKEN);

const app = App.run({
  baseUrl,
  sessionToken,
  node: document.getElementById("application"),
});
const authn = Authn.prepare({
  server: "https://accounts.google.com",
  clientId: config.authn.clientId,
});

app.persistSessionToken.subscribe((sessionToken) => {
  localStorage.setItem(STORAGE_SESSION_TOKEN, sessionToken);
});

app.requestLogin.subscribe(async ({ redirectUri, nonce }) => {
  Authn.login(authn, {
    redirectUri,
    nonce,
  });
});

app.requestLoginCallbackProcessing.subscribe(async () => {
  const id_token = await Authn.validateLogin();
  app.reportLoginReceived(id_token);
});

app.requestLogout.subscribe(() => {
  localStorage.clear(STORAGE_SESSION_TOKEN);
});
